import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import ReactPlayer from "react-player";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../css/Videos.css";

const VIDEO_JSON_URL =
    "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/Videos/videos.json";

const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    adaptiveHeight: false,
};

export default function Videos() {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const controller = new AbortController();

        async function fetchVideos() {
            try {
                const response = await fetch(VIDEO_JSON_URL, {
                    signal: controller.signal,
                    cache: "no-cache",
                });

                if (!response.ok) {
                    throw new Error("Không thể tải danh sách video");
                }

                const data = await response.json();

                if (!Array.isArray(data)) {
                    throw new Error("Dữ liệu video không hợp lệ");
                }

                setVideos(
                    data.filter(
                        (video) =>
                            video.id &&
                            typeof video.title === "string" &&
                            typeof video.url === "string" &&
                            video.url.trim()
                    )
                );
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Lỗi tải video:", err);
                    setError(true);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        }

        fetchVideos();

        return () => controller.abort();
    }, []);

    return (
        <Container fluid className="videos-container">
            <h3 className="video-title">
                NHỮNG KHOẢNH KHẮC ĐÁNG NHỚ QUA ỐNG KÍNH CỦA CHÚNG TÔI
            </h3>

            {loading ? (
                <p className="videos-message">
                    Đang tải danh sách video...
                </p>
            ) : error ? (
                <p className="videos-message">
                    Không thể tải danh sách video. Vui lòng thử lại sau.
                </p>
            ) : videos.length === 0 ? (
                <p className="videos-message">
                    Hiện chưa có video nào.
                </p>
            ) : (
                <Slider {...settings}>
                    {videos.map((video) => (
                        <div key={video.id}>
                            <div className="video-slide">
                                <div className="video-player">
                                    <ReactPlayer
                                        url={video.url}
                                        width="100%"
                                        height="100%"
                                        controls
                                        playing={false}
                                        playsInline
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            )}
        </Container>
    );
}